import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_EE: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astroloogia',
  components_header_media_multi_content_2: 'Meditatsioon',
  components_header_media_multi_content_3: 'Armastus',
  components_header_text1: 'Juhendid',
  components_header_text2: 'Blogi',
  hero_text: 'Leia selgus, tasakaal ja ühendus.',
  hero_button_text: 'Alusta oma teekonda',
  components_ressources_subheader_text: 'Näpunäited ja inspiratsioon',
  components_ressources_span_text: 'See ühendab endas isiklikud astroloogilised teadmised, rahustavad meditatsioonipraktikad ja läbimõeldud armastuse juhendamise, et toetada eneseavastamist, emotsionaalset tasakaalu ja sügavamat ühendust.',
  components_ressources_card_1_title: 'Meditatsiooni näpunäited',
  components_ressources_card_1_text: 'Kiire juhend parema rahunemise, hingamise ja keskendumise saavutamiseks.',
  components_ressources_card_2_title: 'Armastuse juhendamine',
  components_ressources_card_2_text: 'Lihtsad näpunäited tugevama emotsionaalse sideme ja tasakaalu loomiseks.',
  components_ressources_link: 'Avasta rohkem',
  components_notes_and_google_title_1: 'Leia selgus',
  components_notes_and_google_title_2: 'Sisemine rahu',
  components_notes_and_google_title_3: 'Südameühendus',
  media_content_section_multi_1_subheader_text: 'Meie taskuhääling',
  media_content_section_multi_2_subheader_text: 'Meie meditatsioonid',
  media_content_section_multi_3_subheader_text: 'Tõeline jutt kosmilisest romantikast',
  page_media_content_menu_antistress: 'Stressivastane',
  page_media_content_menu_mindfulness: 'Tähelepanelikkus',
  page_media_content_menu_energyboost: 'Energialaks',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Sihtasutused',
  page_media_content_menu_spirituality: 'Vaimsus',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psühholoogia',
  page_media_content_menu_trends: 'Trendid',
  page_media_content_menu_compatibility: 'Ühilduvus',
  page_media_content_menu_love: 'Armastus',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: 'Artiklid ja arusaamad',
  text2_section_button_more: 'Laadi rohkem',
  components_text1_section_title: 'JUHENDID',
  components_text1_subheader_text: 'Kosmilised teadmised igapäevaseks joondamiseks',
  components_text1_span_text: 'Ühtlusta end universumi rütmidega: uuri põhjalike astroloogiliste ja meditatiivsete juhendite kureeritud kogu, mis on loodud sisemise selguse äratamiseks, eneseteadlikkuse süvendamiseks ja sinu hingelise, taevaliku kasvu teekonna toetamiseks.',
  components_text1_card_1_title: 'Avatud vaikusele',
  components_text1_card_1_text: 'Alusta oma teekonda alusmeditatsiooni ja astroloogia juhenditega – ideaalne otsijatele, keda tõmbab sisemise vaikuse, kosmiliste mustrite ja isikliku taipamise poole.',
  components_text1_card_3_title: 'Keha ja vaimu seos',
  components_text1_card_3_text: 'Avasta oma sisemaailma sügavamad kihid. Need teejuhid ulatuvad pinnast kaugemale, et paljastada tähendust, emotsioone ja teadveloleku mustreid, mis kujundavad sinu kogemust.',
  components_text1_card_2_title: 'Mõtiskle ja integreeri',
  components_text1_card_2_text: 'Emotsionaalsetest blokkidest kuni planetaarsete tsükliteni – need teejuhid pakuvad tööriistu mõtiskluseks, tervenemiseks ja transformatsiooniks teadlike rituaalide ja astroloogilise tarkuse kaudu.',
  components_text1_link: 'Kuva kõik juhendid',
  components_footer_text: 'Leia selgus, tasakaalusta oma meel ja loo ühendus tähendusega – sinu koht astroloogia, meditatsiooni ja armastuse jaoks.',
};